import React from 'react';

export default function ScreenCaption({ caption, goback, args }) {

    const hasBack = goback !== undefined;

    return (
        <div className="mb-4">
            <div className="d-flex align-items-center justify-content-between flex-wrap
                            bg-white p-3 rounded shadow-sm border">
                
                {/* Заголовок */}
                <h4 className="m-0 fw-semibold">{caption}</h4>

                {/* Кнопки справа */}
                <div className="d-flex mt-2 mt-sm-0">
                    {hasBack && (
                        <button
                            type="button"
                            className="btn btn-outline-secondary me-2"
                            onClick={() => goback(args)}
                        >
                            ← Назад
                        </button>
                    )}
                    
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => goback({})}
                    >
                        Домой
                    </button>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/ui/screen-caption.js